import axios from 'axios';
import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import BASE_URL from '../../config';

export default function ResetPasswordForm() {
  const { uid, token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      setMsg('');
      return;
    }

    try {
      const res = await axios.post(`${BASE_URL}/api/reset-password/${uid}/${token}/`, { password });
      setMsg(res.data.message || "Password reset successfully.");
      setError('');
      setPassword('');
      setConfirmPassword('');

      setTimeout(() => {
        navigate('/signin');
      }, 2500);
    } catch (err) {
      setError("Something went wrong. Please try again.");
      setMsg('');
    }
  };

  return (
    <div className="reset-password-container">
      <style>{`
        .reset-password-container {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          background: linear-gradient(135deg, #232f3e 0%, #131a22 100%);
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
          padding: 2rem;
        }

        .reset-password-form {
          background: linear-gradient(180deg, #1e2530 0%, #17202d 100%);
          padding: 2.5rem;
          border-radius: 12px;
          border: 1px solid rgba(255, 153, 0, 0.3);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
          width: 100%;
          max-width: 440px;
        }

        .reset-password-form h2 {
          margin: 0 0 1.5rem 0;
          text-align: center;
          color: #ffffff;
          font-size: 1.75rem;
          font-weight: 600;
          letter-spacing: -0.025em;
        }

        .reset-password-form input {
          width: 100%;
          padding: 0.875rem 1rem;
          margin-bottom: 1rem;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 8px;
          font-size: 1rem;
          color: #ffffff;
          transition: all 0.2s ease;
          box-sizing: border-box;
        }

        .reset-password-form input::placeholder {
          color: #aab7c4;
        }

        .reset-password-form input:focus {
          outline: none;
          border-color: #ff9900;
          background: rgba(255, 153, 0, 0.05);
          box-shadow: 0 0 0 3px rgba(255, 153, 0, 0.1);
        }

        .reset-password-form button {
          width: 100%;
          padding: 0.875rem;
          background: linear-gradient(135deg, #ff9900 0%, #ff6600 100%);
          color: #ffffff;
          border: none;
          border-radius: 8px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          margin-top: 0.5rem;
          box-shadow: 0 4px 12px rgba(255, 153, 0, 0.3);
        }

        .reset-password-form button:hover {
          background: linear-gradient(135deg, #ffaa00 0%, #ff7700 100%);
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(255, 153, 0, 0.4);
        }

        .reset-password-form button:active {
          transform: translateY(0);
        }

        .rp-form-message {
          margin-top: 1rem;
          padding: 0.75rem 1rem;
          font-size: 0.9375rem;
          text-align: center;
          border-radius: 6px;
          font-weight: 500;
        }

        .success {
          color: #43b581;
          background: rgba(67, 181, 129, 0.1);
          border: 1px solid rgba(67, 181, 129, 0.3);
        }

        .error {
          color: #ff6b6b;
          background: rgba(240, 71, 71, 0.1);
          border: 1px solid rgba(240, 71, 71, 0.3);
        }

        @media (max-width: 480px) {
          .reset-password-container {
            padding: 1rem;
          }

          .reset-password-form {
            padding: 2rem 1.5rem;
          }

          .reset-password-form h2 {
            font-size: 1.5rem;
          }
        }
      `}</style>

      <form className="reset-password-form" onSubmit={handleSubmit}>
        <h2>Reset Password</h2>
        <input
          type="password"
          placeholder="Enter new password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Confirm new password"
          value={confirmPassword}
          onChange={e => setConfirmPassword(e.target.value)}
          required
        />
        <button type="submit">Reset Password</button>

        {msg && <p className="rp-form-message success">{msg}</p>}
        {error && <p className="rp-form-message error">{error}</p>}
      </form>
    </div>
  );
}
